import { isEmptyValue } from '@octopus-do/octopus-editor'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import * as ActionTypes from '@storeOld/actions'
import cx from 'classnames'
import type React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { useProjectAccess } from '@/hooks'
import { BLOCK_PERMISSION } from '@/permissions/project/definitions'
import { isEditorValue } from '@/utils'
import lightOrDark from '@/utils/color/lightOrDark'
import IconNote from './icons/IconNote'
import css from './Note.module.scss'

type Props = {
  symbolId: string
}

const Note: React.FC<Props> = ({ symbolId }) => {
  const dispatch = useDispatch()
  const { hasAccess } = useProjectAccess(BLOCK_PERMISSION.NOTE)

  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  const symbolItem = useSelector(
    migrationProjectSelector.getProjectSymbolById(symbolId)
  )

  const { content, colorId, title, visual } = useSelector(
    migrationProjectSelector.getProjectSymbolData(symbolId),
    shallowEqual
  )
  const hasImage = visual.type === 'image'

  const colorHex = useSelector(
    migrationProjectSelector.getProjectColorForUI(colorId)
  )

  const isEmpty = !content || !isEditorValue(content) || isEmptyValue(content)
  const hasContent = !isEmpty

  const onClick = () => {
    dispatch({
      type: ActionTypes.OPEN_SYMBOL,
      payload: { symbol: symbolItem },
    })
  }

  if ((!isReadOnly && !hasAccess) || (isReadOnly && !hasContent)) {
    return null
  }

  return (
    <div
      onClick={onClick}
      className={cx(css.container, 'symbol-note', {
        'symbol-note--active': hasContent,
        [css.light]: lightOrDark(colorHex) === 'light',
        [css.hasImage]: hasImage && !title,
      })}
    >
      <div>
        <div className={css.iconContainer}>
          <IconNote />
        </div>
      </div>
    </div>
  )
}

export default Note
